module.exports = __webpack_public_path__ + "img/e298a71fed3f63ef2a6fd363649cd94d.b294b209.jpg";